import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessagesComponent } from '../messages/messages/messages.component';

@Injectable({
  providedIn: 'root'
}) 

export class MessageService {

  message: string = '';
  type: string    = 'alert-info';

  constructor(private matSnackBar: MatSnackBar) { }

  add(message: string, type: string) {
    this.message = message;

    if (type) {
      this.type = `alert-${type}`;
    }

    this.matSnackBar.openFromComponent(MessagesComponent,
      { data: this.message, duration: 4000,  }/* panelClass: ['alert',this.type] */
    );
  }

  clear() {
    this.message = '';
  }

  close() {
    setTimeout(() => {
      this.clear();
    }, 3000);
  }
}
